/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GamificationOutputEventTrigger } from './GamificationOutputEventTrigger';
import {
    GamificationOutputEventTriggerFromJSON,
    GamificationOutputEventTriggerFromJSONTyped,
    GamificationOutputEventTriggerToJSON,
    GamificationOutputEventTriggerToJSONTyped,
} from './GamificationOutputEventTrigger';
import type { GamificationOutputTargetType } from './GamificationOutputTargetType';
import {
    GamificationOutputTargetTypeFromJSON,
    GamificationOutputTargetTypeFromJSONTyped,
    GamificationOutputTargetTypeToJSON,
    GamificationOutputTargetTypeToJSONTyped,
} from './GamificationOutputTargetType';

/**
 * What this mechanic feeds into on milestone or completion
 * @export
 * @interface GamificationOutputConnection
 */
export interface GamificationOutputConnection {
    /**
     * 
     * @type {GamificationOutputTargetType}
     * @memberof GamificationOutputConnection
     */
    targetType: GamificationOutputTargetType;
    /**
     * 
     * @type {string}
     * @memberof GamificationOutputConnection
     */
    targetId: string;
    /**
     * 
     * @type {GamificationOutputEventTrigger}
     * @memberof GamificationOutputConnection
     */
    eventTrigger: GamificationOutputEventTrigger;
    /**
     * Points to add to leaderboard or entries to add to raffle
     * @type {number}
     * @memberof GamificationOutputConnection
     */
    pointsValue?: number;
}



/**
 * Check if a given object implements the GamificationOutputConnection interface.
 */
export function instanceOfGamificationOutputConnection(value: object): value is GamificationOutputConnection {
    if (!('targetType' in value) || value['targetType'] === undefined) return false;
    if (!('targetId' in value) || value['targetId'] === undefined) return false;
    if (!('eventTrigger' in value) || value['eventTrigger'] === undefined) return false;
    return true;
}

export function GamificationOutputConnectionFromJSON(json: any): GamificationOutputConnection {
    return GamificationOutputConnectionFromJSONTyped(json, false);
}

export function GamificationOutputConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationOutputConnection {
    if (json == null) {
        return json;
    }
    return {
        
        'targetType': GamificationOutputTargetTypeFromJSON(json['targetType']),
        'targetId': json['targetId'],
        'eventTrigger': GamificationOutputEventTriggerFromJSON(json['eventTrigger']),
        'pointsValue': json['pointsValue'] == null ? undefined : json['pointsValue'],
    };
}

export function GamificationOutputConnectionToJSON(json: any): GamificationOutputConnection {
    return GamificationOutputConnectionToJSONTyped(json, false);
}

export function GamificationOutputConnectionToJSONTyped(value?: GamificationOutputConnection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetType': GamificationOutputTargetTypeToJSON(value['targetType']),
        'targetId': value['targetId'],
        'eventTrigger': GamificationOutputEventTriggerToJSON(value['eventTrigger']),
        'pointsValue': value['pointsValue'],
    };
}

